import { NativeAudioEngine } from "./native-audio-engine";
import { WebAudioEngine } from "./web-audio-engine";
import type { AudioEngine } from "./types";

/** Same check as `isTauriRuntime()` of apps/web, without loading Tauri modules. */
function isTauriRuntime(): boolean {
  return "__TAURI_INTERNALS__" in globalThis;
}

export type EngineOverride = "web-audio" | "native" | null;

/**
 * Per-platform factory: native (kira via IPC) inside Tauri, Web Audio
 * in browser. `override` allows forcing a backend from the debug UI
 * (?engine=web|native) for the M1 comparative latency measurement.
 */
export function createAudioEngine(override: EngineOverride = null): AudioEngine {
  if (override === "web-audio") {
    return new WebAudioEngine();
  }
  if (override === "native" || isTauriRuntime()) {
    return new NativeAudioEngine();
  }
  return new WebAudioEngine();
}
